import React from "react";
import { COMPANY, buildWhatsAppLink } from "@/lib/constants";
import { MessageCircle, Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-ink text-bone/80 pt-20 pb-10 border-t-2 border-lime-400"
    >
      <div className="max-w-[1500px] mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-12 pb-16 border-b border-bone/15">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <img
                src="/assets/logo.png"
                alt="Royal Eco logo"
                className="w-12 h-12 object-contain"
              />
              <div>
                <div className="font-display text-3xl text-bone">ROYAL ECO</div>
                <div className="tag text-lime-400 mt-1">
                  Gestión Ambiental Responsable
                </div>
              </div>
            </div>
            <p className="text-sm leading-relaxed max-w-md mt-4">
              Más de una década brindando soluciones logísticas y ambientales
              en la Provincia de Buenos Aires. Habilitados por el Ministerio
              de Ambiente PBA (ex-OPDS).
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="tag text-lime-400 mb-5">Servicios</div>
            <ul className="space-y-3 text-sm">
              <li><a href="/transporte-roll-off/" className="hover:text-lime-400 transition-colors">Transporte Roll Off</a></li>
              <li><a href="/roll-off/" className="hover:text-lime-400 transition-colors">Roll Off / Volquetes</a></li>
              <li><a href="/servicios-atmosfericos/" className="hover:text-lime-400 transition-colors">Servicios Atmosféricos</a></li>
              <li><a href="/transporte-residuos-peligrosos/" className="hover:text-lime-400 transition-colors">Transporte de Residuos Peligrosos</a></li>
              <li><a href="#cumplimiento" className="hover:text-lime-400 transition-colors">Cumplimiento Normativo</a></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="tag text-lime-400 mb-5">Contacto</div>
            <ul className="space-y-4 text-sm">
              <li>
                <a
                  href={buildWhatsAppLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp"
                  className="flex items-center gap-3 hover:text-lime-400 transition-colors"
                >
                  <MessageCircle className="w-4 h-4 text-whatsapp" />
                  <span className="font-mono">{COMPANY.whatsappDisplay}</span>
                </a>
              </li>
              <li>
                <a
                  href={`tel:${COMPANY.officeTel}`}
                  data-testid="footer-office"
                  className="flex items-center gap-3 hover:text-lime-400 transition-colors"
                >
                  <Phone className="w-4 h-4" />
                  <span className="font-mono">{COMPANY.officeDisplay}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${COMPANY.email}`}
                  data-testid="footer-email"
                  className="flex items-center gap-3 hover:text-lime-400 transition-colors"
                >
                  <Mail className="w-4 h-4" />
                  {COMPANY.email}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${COMPANY.emailSecondary}`}
                  data-testid="footer-email-secondary"
                  className="flex items-center gap-3 hover:text-lime-400 transition-colors"
                >
                  <Mail className="w-4 h-4" />
                  {COMPANY.emailSecondary}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="w-4 h-4" />
                {COMPANY.region}
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="text-xs text-bone/60">
            © {year} {COMPANY.name}. Todos los derechos reservados. · Habilitación Ministerio de Ambiente PBA.
          </div>
          <div className="tag text-bone/40">DISEÑADO PARA POSICIONAR LA SUSTENTABILIDAD</div>
        </div>
      </div>
    </footer>
  );
}
